<div class="container-fluid-modal">

<form class="form-inline required" #cat="ngForm" (ngSubmit)="cat.form.valid && submitForm(cat.value)" novalidate>
    <div class="add" *ngIf="!editData">
            <div class="ModalHeader">
                <h4 mat-dialog-title>Add Product Category</h4>
                <div class="headerButton">
                    <button type="submit" class="btn btn-success" [disabled]=""><i class="fa fa-floppy-o" aria-hidden="true"></i> Save
                    </button>
                    <button type="button" class="btn btn-warning" matDialogClose (click)="close()"><i
                            class="fa fa-times" aria-hidden="true"></i> Cancel
                    </button>
                </div>
            </div>

            <mat-dialog-content>
                <div class="card">
                    <div class="card-body">

                        <div class="form-group col-lg-12">
                            <label for="Implant" class="labelRequired">Implant </label>
                            <select id="mySelect" data-show-content="true" class="form-control" placeholder="Implant"
                                [(ngModel)]="model.implant_id" name="implant_id" required #implant_id="ngModel" [ngClass]= "{'has-danger': cat?.submitted  && implant_id?.invalid }">
                                <option disabled>Select Implant Type</option>
                                <option *ngFor="let data of implantsData" [value]="data?.id">
                                    {{data?.name}}
                                </option>
                            </select>
                            <div *ngIf="cat?.submitted  && implant_id?.invalid">
                                    <div [hidden]="!implant_id.errors.required" class="formError"> * Implant Type is required </div>
                            </div>
                        </div>

                        <div class="form-group col-lg-12">
                            <label for="Name" class="labelRequired">Name </label>
                            <input type="text" class="form-control" placeholder="Name" name="name" #name="ngModel" [(ngModel)]="user.name" required [ngClass]= "{'has-danger': cat?.submitted  && name?.invalid }">
                        </div>
                        <div *ngIf="cat?.submitted  && name?.invalid ">
                                <div [hidden]="!name.errors.required" class="formError"> * Product Category name is required </div>
                            </div>

                        <div class="form-group col-lg-12">
                            <label for="RK No">RK No </label>
                            <input type="text" class="form-control" placeholder="RK No" name="rk_no" #rk_no="ngModel"
                                ngModel formnovalidate>
                        </div>

                        <div class="form-group col-lg-12">
                            <label for="Title">Title </label>
                            <input type="text" class="form-control" placeholder="Title" name="title" #title="ngModel"
                                ngModel formnovalidate>
                        </div>

                        <div class="form-group col-lg-12">
                            <label for="Range">Range </label>
                            <input type="text" class="form-control" placeholder="Range" name="range" #range="ngModel"
                                ngModel formnovalidate>
                        </div>

                        <div class="form-group col-lg-12">
                            <label for="Description">Description </label>
                            <input type="text" class="form-control" placeholder="Description" name="description"
                                #description="ngModel"
                                ngModel formnovalidate>
                        </div>

                    </div>

                </div>

            </mat-dialog-content>
        </div>

        <div class="edit" *ngIf= "editData">
                <div class="ModalHeader">
                    <h4 mat-dialog-title>Edit Product Category</h4>
                    <div class="headerButton">
                        <button *ngIf="editPermission" type="submit" class="btn btn-success"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save
                        </button>
                        <button type="button" class="btn btn-warning" matDialogClose (click)="close()"><i
                                class="fa fa-times" aria-hidden="true"></i> Cancel
                        </button>
                    </div>
                </div>

                <mat-dialog-content>
                    <div class="card">
                        <div class="card-body">

                            <div class="form-group col-lg-12">
                                <label for="Implant" class="labelRequired">Implant </label>
                                <select id="mySelect" data-show-content="true" class="form-control" placeholder="Implant"
                                [(ngModel)]="implantId" name="implant_id" formnovalidate>
                                    <option disabled>Select Implant Type</option>
                                    <option *ngFor="let data of implantsData" [value]="data?.id">
                                    {{data?.name}}
                                </option>
                                </select>
                            </div>

                            <div class="form-group col-lg-12">
                                <label for="Name" class="labelRequired">Name </label>
                                <input type="text" class="form-control" placeholder="Name" name="name" [(ngModel)]="editData.edit.name" required #name="ngModel" [ngClass]="{'has-danger':cat?.submitted && name?.invalid }">
                                <div *ngIf="cat?.submitted && name?.invalid">
                                    <div [hidden]="!name.errors.required" class="formError"> * Product Category name is required </div>
                                </div>
                            </div>

                            <div class="form-group col-lg-12">
                                <label for="RK No">RK No </label>
                                <input type="text" class="form-control" placeholder="RK No" name="rk_no" [(ngModel)]="editData.edit.rk_no" formnovalidate>
                            </div>

                            <div class="form-group col-lg-12">
                                <label for="Title">Title </label>
                                <input type="text" class="form-control" placeholder="Title" name="title" [(ngModel)]="editData.edit.title" formnovalidate>
                            </div>

                            <div class="form-group col-lg-12">
                                <label for="Range">Range </label>
                                <input type="text" class="form-control" placeholder="Range" name="range" [(ngModel)]="editData.edit.range" formnovalidate>
                            </div>

                            <div class="form-group col-lg-12">
                                <label for="Description">Description </label>
                                <input type="text" class="form-control" placeholder="Description" name="description"
                                [(ngModel)]="editData.edit.description" formnovalidate>
                            </div>

                        </div>

                    </div>

                </mat-dialog-content>
            </div>


    </form>
</div>
